import React from 'react';
import { flushSync } from 'react-dom';
import { createRoot } from 'react-dom/client';
import html2canvas from 'html2canvas';
import { jsPDF } from 'jspdf';
import Invoice from './Invoice';
import { LOGO_IMAGE } from '../components/Brand';

async function logoDataUrl() {
  try {
    const response = await fetch(LOGO_IMAGE);
    if (!response.ok) return LOGO_IMAGE;
    const blob = await response.blob();
    return await new Promise((resolve) => {
      const reader = new FileReader();
      reader.onload = () => resolve(reader.result);
      reader.onerror = () => resolve(LOGO_IMAGE);
      reader.readAsDataURL(blob);
    });
  } catch {
    return LOGO_IMAGE;
  }
}

export async function buildInvoicePdf(order, customer) {
  const logo = await logoDataUrl();
  const host = document.createElement('div');
  host.style.cssText = 'position:fixed;left:-10000px;top:0;width:794px;background:#fff;z-index:-1';
  document.body.appendChild(host);
  const root = createRoot(host);
  try {
    flushSync(() => root.render(React.createElement(Invoice, { order, customer, logo })));
    const paper = host.querySelector('.invoice-paper');
    paper.style.minHeight = '1123px';
    paper.style.width = '794px';
    await Promise.all(Array.from(host.querySelectorAll('img')).map((image) => image.complete
      ? Promise.resolve()
      : new Promise((resolve) => { image.onload = resolve; image.onerror = resolve; })));
    if (document.fonts?.ready) await document.fonts.ready;
    const canvas = await html2canvas(paper, { scale: 2, useCORS: true, backgroundColor: '#ffffff' });
    const pdf = new jsPDF({ unit: 'pt', format: 'a4' });
    const pageWidth = pdf.internal.pageSize.getWidth();
    const pageHeight = pdf.internal.pageSize.getHeight();
    let width = pageWidth;
    let height = (canvas.height * pageWidth) / canvas.width;
    if (height > pageHeight) {
      height = pageHeight;
      width = (canvas.width * pageHeight) / canvas.height;
    }
    pdf.addImage(canvas.toDataURL('image/jpeg', 0.92), 'JPEG', 0, 0, width, height);
    return {
      base64: pdf.output('datauristring').split(',')[1],
      blob: pdf.output('blob'),
      filename: `Invoice-${String(order.invoice_number).replace(/[^a-zA-Z0-9_-]/g, '')}.pdf`
    };
  } finally {
    root.unmount();
    host.remove();
  }
}

export function saveBlob(blob, filename) {
  const url = URL.createObjectURL(blob);
  const anchor = document.createElement('a');
  anchor.href = url;
  anchor.download = filename;
  document.body.appendChild(anchor);
  anchor.click();
  anchor.remove();
  setTimeout(() => URL.revokeObjectURL(url), 60000);
}